import { useState, useEffect } from 'react';
import {
  getCustomerData,
  getDistributorData,
  getOrdersData,
  getRetriveDetails,
  getSalesOrderCustomerTargetData,
  insertSalesPerformanceBarcodeScan,
  updateSalesPerformanceBarcodeQuantityChecked
} from '../../Service/ApiService';
import { useNavigate, useLocation } from 'react-router-dom';
import { validateSalesRetriveOrder } from 'utils/validationUtils';
import { showAlert } from 'utils/ErrorMessage';
import { showSuccessAlert } from 'utils/SuccessMessage';
import { GARMENTUSER, clearSalesOrderWearTypeLock, setSalesOrderWearTypeLock } from 'utils/constants';
const SalesPerformanceController = (initialState, validate) => {
  const [formData, setFormData] = useState(initialState);
  const [customeroptions, setCustomerOptions] = useState([]);
  const [customerdistributor, setDistributorOptions] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [orderdata, setorderdata] = useState([]);
  const [cloading, setcLoading] = useState(false);
  const [selctedcustomer, setSelectedCustomer] = useState('');
  const [selcteddistributor, setSelectedDistributor] = useState('');
  const [selcteddistributorName, setSelectedDistributorName] = useState('');
  const [retailerName, setRetailerName] = useState('self');
  const [errors, setErrors] = useState({});
  const [loadingmessage, setLoadingMessage] = useState('Loading...');
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user'));
  const navState = location?.state || {};
  const navRetailerName = navState?.retailerName || '';
  const navDPartyCode = navState?.dPartyCode || '';
  const [searchText, setSearchText] = useState('');
  const [searchDistText, setSearchDistText] = useState('');
  const [firstLoad, setfirstLoad] = useState(true);
  const [openCustomerInsightsPopup, setOpenCustomerInsightsPopup] = useState(false);
  const [customerInsightsData, setCustomerInsightsData] = useState([]);
  const [customerInsightsMessage, setCustomerInsightsMessage] = useState('');
  const [barcode, setBarcode] = useState('');
  const [barcodeError, setBarcodeError] = useState('');
  const [barcodeRows, setBarcodeRows] = useState([]);
  const [barcodeCount, setBarcodeCount] = useState(0);
  const [isBarcodeLoading, setIsBarcodeLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

 useEffect(() => {
  const savedCustomer = JSON.parse(localStorage.getItem('SelectedCustomer'));
  const savedDistributor = JSON.parse(localStorage.getItem('distributor'));
  const savedDistributorName = JSON.parse(localStorage.getItem('distributorName'));

  if (savedCustomer) {
    setSelectedCustomer(savedCustomer);

    setFormData((prev) => ({
      ...prev,
      customer: {
        value: savedCustomer.partyCode,
        label: savedCustomer.partyName
      },
      address: savedCustomer.address || ''
    }));
  }

  if (savedDistributor) {
    setSelectedDistributor(savedDistributor);
    setSelectedDistributorName(savedDistributorName || '');

    setFormData((prev) => ({
      ...prev,
      distributor: savedDistributor
    }));
  }
}, []);

  // useEffect(() => {
  //   if (user.userVerticalId.toLowerCase().includes(GARMENTUSER.toLowerCase())) {
  //     getDistributor();
  //   }
  // }, [searchDistText]);

  // const handleInputChange = (inputValue) => {
  //   setSearchText(inputValue);
  // };

  // const handleDistributorInputChange = (inputValue) => {
  //   setSearchDistText(inputValue);
  // };

  const handleBarcodeChange = (e) => {
    setBarcode(e.target.value);
    setBarcodeError('');
  };

  const handleBarcodeKeyPress = async (e) => {
    if (e.key !== 'Enter') return;

    const barcodeValue = barcode.trim();
    if (!barcodeValue) {
      setBarcodeError('Please enter a barcode.');
      return;
    }

    if (!selctedcustomer?.partyCode) {
      setBarcodeError('Please select a customer first.');
      return;
    }

    try {
      setIsBarcodeLoading(true);
      const response = await insertSalesPerformanceBarcodeScan(user.userCode, selctedcustomer.partyCode, barcodeValue);
      if (response && response.success) {
        const rowData = response.data || {};
        const newRow = {
          key: rowData.insertId ?? `${rowData.barcode}-${Date.now()}`,
          insertId: rowData.insertId,
          barcode: rowData.barcode || '-',
          materialDesc: rowData.materialDesc || '-',
          quantity: rowData.quantity ?? rowData.qty ?? 0,
          isChecked: 1
        };
        setBarcodeRows((prev) => [newRow, ...prev]);
        setBarcodeCount((prev) => prev + 1);
        setBarcodeError('');
        setBarcode('');
      } else {
        setBarcodeError(response?.msg || 'Unable to fetch barcode data.');
        setBarcode('');
      }
    } catch (error) {
      setBarcodeError('Barcode scan request failed. Please try again.');
      setBarcode('');
    } finally {
      setIsBarcodeLoading(false);
    }
  };


//   useEffect(() => {
//   let scannedBarcode = '';

//   const handleScanner = (e) => {
//     if (e.key === 'Enter') {
//       if (scannedBarcode.trim()) {
//         processBarcode(scannedBarcode.trim());
//       }

//       scannedBarcode = '';
//       return;
//     }

//     if (e.key.length === 1) {
//       scannedBarcode += e.key;
//     }
//   };

//   window.addEventListener('keydown', handleScanner);

//   return () => {
//     window.removeEventListener('keydown', handleScanner);
//   };
// }, [selctedcustomer]);

// const processBarcode = async (barcodeValue) => {
//   if (!barcodeValue) return;

//   if (!selctedcustomer?.partyCode) {
//     setBarcodeError('Please select a customer first.');
//     return;
//   }

//   try {
//     setIsBarcodeLoading(true);

//     const response = await insertSalesPerformanceBarcodeScan(
//       user.userCode,
//       selctedcustomer.partyCode,
//       barcodeValue
//     );

//     if (response && response.success) {
//       const rowData = response.data || {};

//       const newRow = {
//         key: rowData.insertId ?? `${rowData.barcode}-${Date.now()}`,
//         insertId: rowData.insertId,
//         barcode: rowData.barcode || '-',
//         materialDesc: rowData.materialDesc || '-',
//         quantity: rowData.quantity ?? rowData.qty ?? 0,
//         isChecked: 1
//       };

//       setBarcodeRows((prev) => [...prev, newRow]);
//       setBarcodeCount((prev) => prev + 1);
//       setBarcodeError('');
//     } else {
//       setBarcodeError(response?.msg || 'Unable to fetch barcode data.');
//     }
//   } catch (error) {
//     setBarcodeError('Barcode scan request failed. Please try again.');
//   } finally {
//     setIsBarcodeLoading(false);
//   }
// };

  const handleBarcodeClear = () => {
    setBarcode('');
    setBarcodeRows([]);
    setBarcodeCount(0);
    setBarcodeError('');
  };

  const handleBarcodeRowToggle = (index) => {
    setBarcodeRows((prev) =>
      prev.map((row, rowIndex) =>
        rowIndex === index ? { ...row, isChecked: row.isChecked ? 0 : 1 } : row
      )
    );
  };

  const handleBarcodeQtyChange = (index, value) => {
    const sanitized = String(value).replace(/[^0-9]/g, '').replace(/^0+/, '');
    setBarcodeRows((prev) =>
      prev.map((row, rowIndex) =>
        rowIndex === index ? { ...row, quantity: sanitized } : row
      )
    );
  };

  const handleSubmitCheckedBarcodes = async () => {
    if (!barcodeRows.length) {
      setBarcodeError('No scanned barcodes available to submit.');
      return;
    }

    if (!selctedcustomer?.partyCode) {
      setBarcodeError('Please select a customer first.');
      return;
    }

    const checkedRows = barcodeRows.filter((row) => row.isChecked);
    if (!checkedRows.length) {
      await showAlert('Please select at least one barcode.', 'Validation');
      return;
    }

    const hasInvalidQty = checkedRows.some((row) => Number(row.quantity) <= 0);
    if (hasInvalidQty) {
      await showAlert('Quantity must be greater than 0.', 'Validation');
      return;
    }

    const materials = {
      barcodeArray: barcodeRows.map((row) => ({
        insertId: row.insertId,
        barcode: row.barcode,
        materialDesc: row.materialDesc,
        qty: row.quantity,
        isChecked: row.isChecked ? 1 : 0
      }))
    };

    try {
      setIsSubmitLoading(true);
      const confvalue = JSON.parse(localStorage.getItem('confvalue')) || {};
      const cId = confvalue.cID || '';
      const finalDPartyCode = navDPartyCode || (selcteddistributor && selcteddistributor.value) || '';
      const finalRetailerName = navRetailerName || retailerName || '';

      const response = await updateSalesPerformanceBarcodeQuantityChecked(
        user.userCode,
        selctedcustomer.partyCode,
        materials,
        cId,
        finalDPartyCode,
        finalRetailerName
      );
      if (response && response.success) {
        const salesPerformerId = response?.data?.salesPerformerId;
        const successMessage = salesPerformerId
          ? `${response.msg || 'Sales Order Performa created successfully'} - SP-${salesPerformerId}`
          : response.msg || 'Sales Order Performa created successfully';

        await showSuccessAlert(
          successMessage,
          'Success'
        );

        navigate('/salesorder');
        return;
      } else {
        await showAlert(response?.msg || 'Unable to submit scanned barcodes', 'Error');
      }
    } catch (error) {
      await showAlert('Barcode submit request failed. Please try again.', 'Error');
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const getOrders = async (customerid) => {
    try {
      setLoadingMessage('Orders Loading...');
      setcLoading(true);
      // console.log("USER",user);
      setorderdata([]);
      const response = await getOrdersData(user.userCode, customerid);
      // console.error('Return Response:', response);
      if (response && response.success === 'true') {
        setorderdata(response.orderList);
      } else {
        setorderdata([]);
      }
      await getCustomerInsights(customerid);
      setcLoading(false);
    } catch (error) {
      // console.error('Error during login:', error);
      setCustomerInsightsData([]);
      setcLoading(false);
    }
  };

  const getOrdersAfterCancel = async (customer) => {
    try {
      setLoadingMessage('Orders Loading...');
      setcLoading(true);
      // console.log("USER",user);
      const response = await getOrdersData(customer.userCode, customer.partyCode);
      // console.error('Return Response:', response);
      if (response && response.success === 'true') {
        setorderdata(response.orderList);
      } else {
        setorderdata([]);
      }
      setcLoading(false);
    } catch (error) {
      // console.error('Error during login:', error);
      setcLoading(false);
    }
  };

  const getCustomerInsights = async (customerid) => {
    try {
      const response = await getSalesOrderCustomerTargetData(user.userCode, customerid);
      const rows = Array.isArray(response?.data)
        ? response.data.map((row, index) => ({
          id: row.id || `${customerid}-${index}`,
          categoryName: row.categoryName || '-',
          targetInMeters: row.targetInMeters ?? row.targetMtr ?? '0',
          salesInRolls: row.salesInRolls ?? row.rolls ?? '0',
          targetValue: row.targetValue ?? '0',
          partyName: row.partyName || ''
        }))
        : [];

      setCustomerInsightsData(rows);
      setCustomerInsightsMessage(rows.length > 0 ? '' : response?.msg || 'No category sales data available');
      setOpenCustomerInsightsPopup(rows.length > 0);
    } catch (error) {
      setCustomerInsightsData([]);
      setCustomerInsightsMessage('No category sales data available');
      setOpenCustomerInsightsPopup(false);
    }
  };

  const getDistributor = async () => {
    try {
      setLoadingMessage('Distributor Loading...');
      setcLoading(true);
      const response = await getDistributorData(user.userCode, searchDistText);
      // console.error('Return Response:', response);
      if (response && response.success === 'true') {
        setDistributorOptions([]);
        // comment this functionality for remove duplicate partycode data - 6 June
        // const distributorOptions = response.distributorList.map((item) => ({
        //   value: item.partyCode.toString(),
        //   label: item.partyName+"-"+item.city+"-"+item.partyCode.toString(),
        //   partyName: item.partyName
        // }));
        // setDistributorOptions(distributorOptions);
        const uniqueDistributorOptions = response.distributorList.reduce((uniqueList, currentItem) => {
          // Check if the partyCode of the current item is already present in the unique list
          const existingItem = uniqueList.find((item) => item.value === currentItem.partyCode.toString());

          // If the partyCode is not already in the unique list, add it
          if (!existingItem) {
            uniqueList.push({
              value: currentItem.partyCode.toString(),
              label: currentItem.partyName + '-' + currentItem.city + '-' + currentItem.partyCode.toString(),
              partyName: currentItem.partyName
            });
          }

          return uniqueList;
        }, []);
        setDistributorOptions(uniqueDistributorOptions);
      }

      setcLoading(false);
      setfirstLoad(false);
    } catch (error) {
      // console.error('Error during login:', error);
      setcLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formData, user.userVerticalId, user.confSpart);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      // Reset the wear type lock when a fresh sales order starts.
      clearSalesOrderWearTypeLock();
      localStorage.setItem('customer', JSON.stringify(selctedcustomer));
      localStorage.setItem('headerCustomer', JSON.stringify(selctedcustomer));
      localStorage.setItem('distributor', JSON.stringify(selcteddistributor));
      localStorage.setItem('distributorName', JSON.stringify(selcteddistributorName));
      localStorage.setItem('orderupdatedList', null);
      localStorage.setItem('showordernumber', 0);
      localStorage.setItem('ordernumber', '');
      localStorage.setItem('materialListupdate', null);
      localStorage.setItem('materialList', null);
      localStorage.setItem('isRetrieve', null);
      localStorage.setItem('fromritrival', null);
      localStorage.setItem('retailerName', JSON.stringify(retailerName?.trim()));
      localStorage.setItem('scheduledData', null);
      localStorage.setItem('fromreplicate', null);
      localStorage.setItem('barcodenotfoundmaterialList', null);
      navigate('/barcodedashboard');
    }
    // localStorage.setItem("customer",selctedcustomer.label);
    // localStorage.setItem("distributor",selcteddistributor.label);

    // if (Object.keys(validationErrors).length === 0) {
    //   console.error('formData:', formData);

    // }
  };

  const handleRetriveSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateSalesRetriveOrder(formData);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      try {
        setcLoading(true);
        const response = await getRetriveDetails(selctedcustomer.partyCode, user.userVerticalId);
        localStorage.setItem('materialList', null);
        //console.error('Return Response:', response);
        if (response && response.success === 'true') {
          const filteredMaterialList = response.materialList.filter((item) => item.balanceQty !== '0');
          // Seed the wear type lock from retrieved order data for add-more validation.
          setSalesOrderWearTypeLock(filteredMaterialList[0]?.wearType || response.materialList[0]?.wearType || '');

          const modifiedResponse = {
            ...response,
            materialList: filteredMaterialList
          };
          localStorage.setItem('materialList', JSON.stringify(modifiedResponse));
          localStorage.setItem('distributor', JSON.stringify(selcteddistributor));
          localStorage.setItem('distributorName', JSON.stringify(selcteddistributorName));
          localStorage.setItem('customer', JSON.stringify(selctedcustomer));
          localStorage.setItem('headerCustomer', JSON.stringify(selctedcustomer));
          localStorage.setItem('orderupdatedList', null);
          localStorage.setItem('showordernumber', 0);
          localStorage.setItem('ordernumber', '');
          localStorage.setItem('materialListupdate', null);
          localStorage.setItem('retailerName', JSON.stringify(retailerName?.trim()));
          localStorage.setItem('isRetrieve', '1');
          localStorage.setItem('fromritrival', '1');
          localStorage.setItem('fromreplicate', null);

          if (user.userVerticalId == 'Fabric') {
            navigate('/stockselectionf');
          } else {
            navigate('/stockselectiong');
          }

          setcLoading(false);
        } else {
          showAlert('Data Not Found', 'No Data');
          setcLoading(false);
          return false;
        }
      } catch (error) {
        setcLoading(false);
        // console.error('Error during login:', error);
        return false;
      }
    }
  };

  const findCustomerByPartyCode = (partyCode) => {
    // console.log("My Partycode",customerList);
    const customer = customerList.find((customer) => customer.partyCode === partyCode.value);
    return customer ? customer : null;
  };

  const handleCustomerChange = (e) => {
    getOrders(e.value);
    // setSelectedCustomer(e.target.value);
    const customer = findCustomerByPartyCode(e);
    setSelectedCustomer(customer);
    localStorage.setItem('customer', JSON.stringify(customer));
    localStorage.setItem('headerCustomer', JSON.stringify(customer));
    localStorage.setItem('SelectedCustomer', JSON.stringify(customer));
    setFormData({
      ...formData,
      ['customer']: e,
      ['address']: customer.address
    });

    setErrors({
      ...errors,
      ['customer']: ''
    });
  };

  const handleAddressChange = (e) => {
    // console.log(e);
    let inputValue = e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: inputValue
    });

    setErrors({
      ...errors,
      [e.target.name]: ''
    });
  };

  const handleRetailerChange = (e) => {
    setRetailerName(e.target.value);
    let inputValue = e.target.value;
    const validValue = inputValue.replace(/[^a-zA-Z0-9 ,.]/g, '');
    console.log('validValue', validValue);
    setFormData({
      ...formData,
      [e.target.name]: validValue
    });

    setErrors({
      ...errors,
      [e.target.name]: ''
    });
  };

  const handleDistributorChange = (e) => {
    // console.log(e);
    setSelectedDistributorName(e.partyName);
    setSelectedDistributor(e);
    setFormData({
      ...formData,
      ['distributor']: e
    });

    setErrors({
      ...errors,
      ['distributor']: ''
    });
  };

  return {
    loadingmessage,
    orderdata,
    formData,
    user,
    cloading,
    errors,
    customeroptions,
    customerdistributor,
    selctedcustomer,
    firstLoad,
    handleDistributorChange,
    handleCustomerChange,
    handleSubmit,
    handleRetriveSubmit,
    handleAddressChange,
    handleRetailerChange,
    // handleInputChange,
    // handleDistributorInputChange,
    getOrdersAfterCancel,
    openCustomerInsightsPopup,
    setOpenCustomerInsightsPopup,
    customerInsightsData,
    customerInsightsMessage,
    barcode,
    barcodeError,
    barcodeRows,
    barcodeCount,
    isBarcodeLoading,
    isSubmitLoading,
    handleBarcodeChange,
    handleBarcodeKeyPress,
    handleBarcodeClear,
    handleBarcodeRowToggle,
    handleSubmitCheckedBarcodes,
    handleBarcodeQtyChange
  };
};

export default SalesPerformanceController;
